import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function PatientScrollArrowTemplate({ direction, scrollPatient, disabled }) {
    const label = direction === "right" ? "Next Patient" : "Previous Patient";
    return (
       <div className='u-display--ib u-flex--center u-mar--x--sml'>
             { !disabled ? 
                <BaasicButton
                    className="btn btn--icon--sml-med btn--icon"
                    icon={`u-icon u-icon--med u-icon--arrow-${direction}--enabled`}
                    label={label}
                    onlyIcon={true}
                    onClick={() => scrollPatient()}
                ></BaasicButton> :
                <BaasicButton
                    className="btn btn--icon--sml-med btn--base btn--icon"
                    icon={`u-icon u-icon--med u-icon--arrow-${direction}--disabled`}
                    label={label}
                    onlyIcon={true}
                    onClick={() => {}}
                ></BaasicButton>
             }
       </div>
    )
}
 
PatientScrollArrowTemplate.propTypes = {
    direction: PropTypes.string,
    scrollPatient: PropTypes.func,
    disabled: PropTypes.bool
};

export default defaultTemplate(PatientScrollArrowTemplate);
